<div [class.flex-wrap]="wrap"
     [class.h-[72px]]="!wrap"
     [class.h-auto]="wrap"
     [class.min-h-[72px]]="wrap"
     class="flex flex-row w-full px-6 py-3.5 text-lg text-gray-900 items-center font-medium shadow-full justify-between shrink-0 relative z-10 gap-4">
  <ng-content></ng-content>
</div>
